<template>
  <div class="flex items-center gap-2.5 px-3.5 h-[70px]">
    <a @click="gotoHome" class="flex items-center gap-2.5 cursor-pointer">
      <img class="w-[40px] h-[40px]" src="/logo/IOC-160X160.png" />
    </a>
    <div class="flex flex-col">
      <span class="text-sm font-bold text-inverse grow text-cyan-400"> INNOVARE OPTIMA CONSULTING </span>
      <span class="text-xs text-inverse grow text-gray-300"> Broker Management System </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AmsSidebarHeader",
  methods: {
    gotoHome() {
      this.$router.push("/");
    },
  }
};
</script>
